import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { isOperatorAuthenticated } from '../../utils/authUtils';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * A wrapper component that protects routes requiring operator authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const location = useLocation();
  const [search] = useSearchParams();

  if (!isOperatorAuthenticated()) {
    // Redirect to login page with the current location for redirect after login
    return (
      <Navigate
        to="/training/login"
        state={{ from: location, config: search.get('config') }}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
